import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/layout/Layout';
import { PageHero, SEOContent, CTASection } from '../components/shared';
import { pageHeroImages } from '../data/mock';

const teamMembers = [
  {
    id: 'mischa',
    name: 'Mischa von Bergh',
    title: 'Facharzt für Allgemeinmedizin',
    image: '/images/Mischa_von_Bergh.webp'
  },
  {
    id: 'martin',
    name: 'Martin von Bergh',
    title: 'Facharzt für Allgemeinmedizin, Notfallmedizin',
    image: '/images/Martin_von_Bergh.webp'
  },
  {
    id: 'kirchner',
    name: 'Dr. med. Franz-Ferdinand Kirchner',
    title: 'Facharzt für Kardiologie',
    image: '/images/Dr_Kirchner.webp'
  },
  {
    id: 'marcel',
    name: 'Marcel Blaschczyk',
    title: 'Arzt',
    image: '/images/Marcel_Blaschczyk.webp'
  }
];

export const TeamPage = () => {
  return (
    <Layout>
      <PageHero
        title="Das Team der Gemeinschaftspraxis Dres. von Bergh"
        subtitle="Ärzte und Mitarbeiter – gemeinsam für Ihre Gesundheit."
        backgroundImage={pageHeroImages.team}
        showCTA={false}
      />

      <section className="py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-2xl md:text-3xl font-semibold text-[#0b382a] mb-4">
              Ihre Hausärzte im Medicum Diez
            </h2>
            <p className="text-[#0b382a]/70 max-w-2xl mx-auto">
              Dr. Martin von Bergh, Dr. Mischa von Bergh und das gesamte Praxisteam begleiten Sie kompetent, persönlich und kontinuierlich.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <div className="relative mb-4 overflow-hidden rounded-2xl aspect-square">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-lg font-semibold text-[#0b382a] mb-1">
                  {member.name}
                </h3>
                <p className="text-[#0b382a]/70 text-sm">
                  {member.title}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-[#eff0f0]">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto text-center"
          >
            <h2 className="text-2xl md:text-3xl font-semibold text-[#0b382a] mb-6">
              Unser Praxisteam
            </h2>
            <p className="text-[#0b382a]/70 leading-relaxed">
              Neben unseren Ärzten sorgen unsere medizinischen Fachangestellten für einen reibungslosen Praxisablauf, 
              freundliche Betreuung und professionelle Unterstützung bei allen organisatorischen Anliegen.
            </p>
          </motion.div>
        </div>
      </section>

      <SEOContent
        title="Ärzte und Praxisteam in Diez"
        content="In der Gemeinschaftspraxis Dres. von Bergh im Medicum Diez arbeiten erfahrene Hausärzte und medizinische Fachangestellte für eine verlässliche hausärztliche Versorgung."
      />

      <CTASection
        title="Termin vereinbaren"
        subtitle="Lernen Sie unser Team persönlich kennen."
        buttonText="Jetzt Termin buchen"
      />
    </Layout>
  );
};

export default TeamPage;
